import { createContext } from 'react'
import { Language, Locales, LocalizedText, Text, LanguageDictionary, LocaleName } from './language'
import { API, URLS } from './http'
import { Participant, ParticipantDeregisterData, ParticipantRegisterData, RelatedParticipant } from './Models/participant'
import { DropdownData, LegacyJsonResponse } from './Models/system'

export interface LanguageResources {
  language: Language,
  locale: Locale,
  localizedText: LocalizedText,
  setLanguage?: (language: Language) => void
}

export function getLanguageResources(language: Language, setLanguage?: (language: Language) => void) {
  const AllLanguageResources: LanguageDictionary<LanguageResources> = {
    English: {
      language: 'English',
      locale: Locales.English,
      localizedText: Text.English,
      setLanguage
    },
    French: {
      language: 'French',
      locale: Locales.French,
      localizedText: Text.French,
      setLanguage
    },
  }
  return AllLanguageResources[language]
}

export const DefaultLanguageResources = getLanguageResources('English')

export const LanguageContext = createContext(DefaultLanguageResources)

export const isUserLoggedIn = () => !!window.__GLOBALS__.PublicUserId

export const getUserName = () => window.__GLOBALS__.PublicUserName

export const getUserId = () => window.__GLOBALS__.PublicUserId

export const canUserAdmin = () => window.__GLOBALS__.PublicUserCanAdministrate

export const getUserLocale = () => window.__GLOBALS__.PublicUserLocale

export const setUserLocale = (locale: LocaleName) => window.__GLOBALS__.PublicUserLocale = locale

export const logUserOut = () => {
  window.__GLOBALS__.PublicUserId = undefined
  window.__GLOBALS__.PublicUserName = undefined
  window.__GLOBALS__.PublicUserCanAdministrate = false

  window.location.href = URLS.WORKSHOPS_LOGOUT

  // API.logout()
}

export const goToPortalDashboard = () => {
  window.location.href = URLS.IDENTITY_SERVER_DASHBOARD
}

export const loginAndReturn = () => {
  const currentUrl = encodeURI(window.location.href)

  window.location.href = URLS.IDENTITY_SERVER_LOGIN_AND_RETURN + currentUrl
}

export const UserInfo = {
  isUserLoggedIn, getUserName, getUserId, getUserLocale, setUserLocale, canUserAdmin, logUserOut, goToPortalDashboard, loginAndReturn
}

export interface UserParticipantInfo {
  participant: Participant
  registerParticipant?: (participant: Participant, additionalParticipant: RelatedParticipant | undefined, workshopEventId: number) => Promise<LegacyJsonResponse<ParticipantRegisterData>>
  deregisterParticipant?: (workshopEventId: number) => Promise<LegacyJsonResponse<ParticipantDeregisterData>>
  refreshWorkshops?: () => Promise<void>
}

export const AnonParticipant: Participant = {
    AccessibilityRequirement: '',
    AddressLine1: '', 
    AddressLine2: '',
    City: '',
    CommodityCategoryId: null,
    CommoditySubCategoryId: null,
    DateCreated: new Date(),
    Email: '',
    IsCertifiedOrganic: false,
    IsOrganicCertificationPending: false,
    LanguageId: null,
    MunicipalityTier1Id: null,
    MunicipalityTier2Id: null,
    NameFirst: '',
    NameLast: '',
    RelatedParticipants: [],
    Phone1: null,
    Phone1Extension: null,
    Phone2: null,
    Phone2Extension: null,
    PostalCode: '',
    ProvinceId: null,
    RegistrationId: 0,
    WatershedId: null,
    ParticipantId: 0,
    PublicUserIdLink: 0
} as any as Participant

export const UserParticipantContext = createContext<UserParticipantInfo>({ participant: AnonParticipant })

export const EmptyDropdownData:DropdownData = {
  locationTier1:[], 
  locationTier2: [], 
  locationTier2ParentIds: {}, 
  commodityCategory: [], 
  commoditySubCategory: [],
  commoditySubCategoryParentIds: {}, 
  province: [],
  watershed: [], 
  language: [],
  workshopType: []
}

export const DropdownContext = createContext<DropdownData>(EmptyDropdownData)